import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import RewardsModal from "../../pages/rewardsModal/rewardsModal";
import RewardsSponsorModal from "../../pages/rewardsSponsorModal/rewardssponsorModal";
const Goals = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);
  const [rewardsModal, setrewardsModal] = useState(false);
  const [showrewards, setShowrewards] = useState(false);
  const [showModalRewards, setShowModalRewards] = useState(false);
    const [showModalRewardsSponsor, setShowModalRewardsSponsor] = useState(false);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);
  const hasRewards =
    data.available_loyalty_rewards?.length > 0 ;
    

    const hasRewardsSposorship = data.available_sponsorship_rewards?.length > 0;

  if (!languageData) {
    return <div></div>;
  }
  const loyaltyPercentage = Number(data?.loyalty?.[0]?.percentage ?? 0);
  const SponsorshipCredits = Number(data?.sponsorship?.[0]?.percentage ?? 0);

  return (
    <>
      <div className="col-xxl-12 col-md-6 text-left">
        <div className="card custom-card">
          <div className="card-header d-flex justify-content-between">
            <div className="flex-1">
              <div className="card-title">{languageData.goals.title}</div>
            </div>
          </div>
          <div className="card-body">
            <ul className="list-unstyled mb-0">
              <li className="list-item mb-4">
                <div className="d-flex align-items-start pos-relative">
                  <div className="me-2">
                    <Link
                      to="/profile?tab=loyalty"
                      aria-label="anchor"
                      className="avatar bg-info-transparent text-info text-none"
                   
                    >
                      <i className="bi bi-star-fill"></i>
                    </Link>
                  </div>

                  <div className="flex-1 mx-2">
                    <div className="d-flex align-items-start justify-content-between mb-2">
                      <span className="flex-1 fw-semibold">
                        {languageData.goals.loyalty}
                      </span>
                      <span className="min-w-fit-content ms-1 text-info">
                        {loyaltyPercentage}%
                      </span>
                    </div>
                    <div
                      className="progress progress-xs progress-custom progress-animate"
                      role="progressbar"
                      aria-valuenow={loyaltyPercentage}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div
                        className="progress-bar bg-info"
                        style={{ width: `${loyaltyPercentage}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              </li>
               {hasRewards && (
              <div className="flex align-items-center justify-content-center mb-4">
                <button data-interaction="open_modal_loyalty"
                  className="btn btn-primary  btn-sm"
                  onClick={() => setShowModalRewards(true)}
                >
                  {languageData.goals.button}
                </button>
              </div>
            )}
              <li class="list-item mb-4">
                <div class="d-flex align-items-start pos-relative">
                  <a
                    aria-label="anchor"
                    href="javascript:void(0);"
                    class="masked-link z-1"
                  ></a>
                  <div class="me-2">
                    <Link
                      to="/profile?tab=sponsorship"
                      aria-label="anchor"
                      className="avatar bg-info-transparent text-info text-none "
                    >
                      <i className="bi bi-cash-coin"></i>
                    </Link>
                  </div>
                  <div class="flex-1 mx-2">
                    <div class="d-flex align-items-start justify-content-between mb-2">
                      <span class="flex-1 fw-semibold">
                        {languageData.goals.sponsorship}
                      </span>
                      <span class="min-w-fit-content ms-1 text-info">
                        {SponsorshipCredits}%
                      </span>
                    </div>
                    <div
                      class="progress progress-xs progress-custom progress-animate"
                      role="progressbar"
                      aria-valuenow={SponsorshipCredits}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div
                        class="progress-bar bg-info"
                        style={{ width: `${SponsorshipCredits}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              </li>
               {hasRewardsSposorship && (
              <div className="flex align-items-center justify-content-center mb-4">
                <button data-interaction="open_modal_sponsorship"
                  className="btn btn-primary btn-sm"
                  onClick={() => setShowModalRewardsSponsor(true)}
                >
                  {languageData.goals.button}
                </button>
              </div>
            )}
            </ul>
           
          </div>
        </div>
      </div>
      <RewardsModal
        show={showModalRewards}
        onClose={() => setShowModalRewards(false)}
        loyaltyRewards={data.available_loyalty_rewards}
      />
       <RewardsSponsorModal
        show={showModalRewardsSponsor}
        onClose={() => setShowModalRewardsSponsor(false)}
        sponsorshipRewards={data.available_sponsorship_rewards}
      />
    </>
  );
};

export default Goals;
